// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M2.5 2.75 L5.06 2.75 C5.65 2.75 6.17 3.19 6.36 3.69 L9.64 12.31 C9.83 12.81 10.35 13.25 10.94 13.25 L13.5 13.25',
  'M9.5 2.75 L13.5 2.75',
];
